import { createFileRoute } from '@tanstack/react-router'

import { UnsExplorer } from '@/components/UnsExplorer'

export const Route = createFileRoute('/_app/oilandgas/explorer')({
  component: OilAndGasExplorerPage,
})

function OilAndGasExplorerPage() {
  return (
    <UnsExplorer
      wsAddress={import.meta.env.VITE_SHARED_WS_ADDRESS}
      username={import.meta.env.VITE_WS_USERNAME}
      password={import.meta.env.VITE_WS_PASSWORD}
      rootName="OGCorp"
      topicFilters="OGCorp/#"
      clientIdPrefix="stories_uns_oilandgas"
    />
  )
}
